// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"392":"ccde2cb8","453":"02fed68a"}[chunkId] + ".chunk.js";
};